export default {
  name: 'analytic',
  path: 'analytic',
  component: () => import(/* webpackChunkName: "analytic" */ '@/views/report/analytic/index'),
};
